module.exports = __webpack_public_path__ + "static/media/watermelon.28a5c80a.svg";